import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { GenerateAndDownloadQuotationAnalysisFormPDFDto } from "@interfaces/dto/generateAndDownloadQuotationAnalysisFormPDFDto";
import { Service } from "@services/service";

@Injectable()
export class QuotationAnalysisFormService extends Service {
	constructor(injector: Injector) {
		super("QuotationAnalysisForm", injector);
	}
	
	// API	
	approve(id: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Approve/${id}`, {});
	}

	defaultSettings(){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/DefaultSettings`);
	}

	generateAndPreviewPdf(dto: GenerateAndDownloadQuotationAnalysisFormPDFDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/GenerateAndPreviewPdf`, dto, { responseType: "blob" as "json"} );
	}

	// Creates a draft Part for this QAF and every QAF below it, skipping part numbers that are already Parts.
	generateParts(id: number) {
		return this.http.post<any>(`${environment.server.apiURL}/${this.endpoint}/GenerateParts/${id}`, {});
	}

	getByCrmOpportunityId(id: number){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByCrmOpportunityId/${id}`);
	}

	getByParentId(id: number){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByParentId/${id}`);
	}

	getChangeLog(id: number){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ChangeLog/${id}`);
	}

	getDescendantsById(id: number){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetDescendantsById/${id}`);
	}

	// Every QAF quoted for a client, child QAFs included - the combined-quote picker.
	getForClient(clientId: number){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetForClient/${clientId}`);
	}

	getWithNoParent(){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetWithNoParent`);
	}
	
	removeCrmOpportunityFromQAF(id: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/RemoveCrmOpportunityFromQAF/${id}`, {});
	}

	removeParentFromQAF(id: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/RemoveParentFromQAF/${id}`, {});
	}

	setCrmOpportunityForQAF(id: number, crmOpportunityId: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/SetCrmOpportunityForQAF/${id}/${crmOpportunityId}`, {});
	}

	setParentForQAF(id: number, parentId: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/SetParentForQAF/${id}/${parentId}`, {});
	}
}